import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "@/lib/router";
import { useLang } from "@/context/LanguageContext";

const COPY = {
  title: { it: "Pagina non trovata", en: "Page not found", de: "Seite nicht gefunden", es: "Página no encontrada", fr: "Page introuvable" },
  text: {
    it: "La pagina che cerchi non esiste o è stata spostata. Lascia che ti riportiamo nell'universo VORNX.",
    en: "The page you are looking for doesn’t exist or has been moved. Let us guide you back to the VORNX universe.",
    de: "Die gesuchte Seite existiert nicht oder wurde verschoben. Wir führen Sie zurück in das Universum von VORNX.",
    es: "La página que buscas no existe o ha sido movida. Déjanos guiarte de vuelta al universo VORNX.",
    fr: "La page que vous cherchez n'existe pas ou a été déplacée. Laissez-nous vous ramener dans l'univers VORNX.",
  },
  cta: { it: "Torna alla Home", en: "Return Home", de: "Zur Startseite", es: "Volver al inicio", fr: "Retour à l'accueil" },
};

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <main data-testid="not-found-page" className="grain relative flex min-h-screen flex-col items-center justify-center bg-ink px-6 text-center">
      <Helmet><meta name="robots" content="noindex, nofollow" /></Helmet>
      <span className="text-xs uppercase tracking-overline text-gold">404</span>
      <h1 className="mt-6 font-display text-5xl font-light tracking-tight text-gold sm:text-7xl">{t(COPY.title)}</h1>
      <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">{t(COPY.text)}</p>
      <button
        onClick={() => navigate("/")}
        data-testid="notfound-home-btn"
        className="mt-10 rounded-none bg-gold px-9 py-4 text-xs uppercase tracking-widest text-ink transition-colors duration-300 hover:bg-gold-muted"
      >
        {t(COPY.cta)}
      </button>
    </main>
  );
}
